/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
==========================================================================================*/
import {
  register,
  login,
  confirmOtp,
  confirmLoginOtp,
  ConfirmOtpRegisterByNationalId
} from "src/api-services/account";

const actions = {
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({
    commit
  }, width) {
    commit("UPDATE_VERTICAL_NAV_MENU_WIDTH", width);
  },

  // VxAutoSuggest
  updateStarredPage({
    commit
  }, payload) {
    commit("UPDATE_STARRED_PAGE", payload);
  },

  // The Navbar
  arrangeStarredPagesLimited({
    commit
  }, list) {
    commit("ARRANGE_STARRED_PAGES_LIMITED", list);
  },
  arrangeStarredPagesMore({
    commit
  }, list) {
    commit("ARRANGE_STARRED_PAGES_MORE", list);
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({
    commit
  }) {
    commit("TOGGLE_CONTENT_OVERLAY");
  },
  updateTheme({
    commit
  }, val) {
    commit("UPDATE_THEME", val);
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  setUserInfo({
    commit
  }, payload) {
    commit("SET_USER_INFO", payload);
  },

  setAccountInfo({
    commit
  }, payload) {
    commit("SET_ACCOUNT_INFO", payload);
  },

  async registerUser({
    commit
  }, payload) {
    try {
      const response = await register(payload);

      // Set bearer token in axios
      commit("SET_ACCESS_TOKEN", response.result.authToken);
    } catch (error) {
      // handle the error here
    }
  },
  async login({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      login(payload)
        .then(response => {
          // Set authToken
          const token = response.data.result.authToken;
          // const userStep = response.data.result.quizInfoCompletion ? "completed" : response.data.result.userInfoCompletion ? "quiz" : "personalInfo";
          // commit("SET_USER_STEP", userStep);
          commit("SET_USER_ID", response.data.result.id);

          localStorage.setItem("hasLoginedYet", true);
          localStorage.setItem("passwordExpired", response.data.result.passwordExpired)

          // Set bearer token in axios
          commit("SET_ACCESS_TOKEN", token);
          commit("SET_REFRESH_TOKEN", response.data.result.refreshToken);
          resolve({
            success: response.data.success
          });
        })
        .catch(error => {
          reject(error);
          // handle the error here
        });
    });
  },
  confirmOtp({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      confirmOtp(payload)
        .then(response => {
          const result = response.data.result;
          if (response.data.success) {
            const token = result.authToken;
            const userStep = result.quizInfoCompletion ?
              "completed" :
              result.userInfoCompletion ?
              "quiz" :
              "personalInfo";

            commit("SET_USER_STEP", userStep);

            // Set bearer token in axios
            commit("SET_ACCESS_TOKEN", token);
            commit("SET_REFRESH_TOKEN", result.refreshToken);
            commit("SET_USER_ID", result.id)
            commit("SET_USER_STEP", userStep);
          }
          resolve({
            success: response.data.success,
            response
          });
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  confirmLoginOtp({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      confirmLoginOtp(payload)
        .then(response => {
          const result = response.data.result;
          if (response.data.success) {
            const token = result.authToken;
            const userStep = result.quizInfoCompletion ?
              "completed" :
              result.userInfoCompletion ?
              "quiz" :
              "personalInfo";

            commit("SET_USER_STEP", userStep);

            // Set bearer token in axios
            commit("SET_ACCESS_TOKEN", token);
            commit("SET_REFRESH_TOKEN", result.refreshToken);
            commit("SET_USER_ID", result.id)
            commit("SET_USER_STEP", userStep);
          }
          resolve({
            success: response.data.success,
            response
          });
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  setAccessToken({
    commit
  }, payload) {
    commit("SET_ACCESS_TOKEN", payload);
  },
  setUserStep({
    commit
  }, payload) {
    commit("SET_USER_STEP", payload);
  },
  setTokenExpired({
    commit
  }, payload) {
    commit("SET_TOKEN_EXPIRED", payload);
  },
  setCurrentTicket({
    commit
  }, payload) {
    commit("SET_CURRENT_TICKET", payload);
  },
  setCategories({
    commit
  }, payload) {
    commit("SET_CATEGORIES", payload);
  },

  confirmOtpRegisterByNationalIds({
               commit
             }, payload) {
    return new Promise((resolve, reject) => {
      ConfirmOtpRegisterByNationalId(payload)
        .then(response => {
          const result = response.data.result;
          if (response.data.success) {
            const token = result.authToken;
            // const userStep = result.quizInfoCompletion ?
            //   "completed" :
            //   result.userInfoCompletion ?
            //     "quiz" :
            //     "personalInfo";

            // commit("SET_USER_STEP", userStep);

            // Set bearer token in axios
            commit("SET_ACCESS_TOKEN", token);
            commit("SET_REFRESH_TOKEN", result.refreshToken);
            commit("SET_USER_ID", result.id)
            // commit("SET_USER_STEP", userStep);
          }
          resolve({
            success: response.data.success,
            response
          });
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};


export default actions;
